// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"PlanScreen_buttonsContainer__5gFy4","button":"PlanScreen_button__zDvJw"};